import { CardUIExtension, ICardUIExtensionContext } from 'tessa/ui/cards';
import { Guid, Visibility } from 'tessa/platform';
import { TaskViewModel } from 'tessa/ui/cards/tasks';
import { CdCardTypes } from 'src/cdScripts/Helpers/CdCardTypes';

export class CdHideSubTaskTableUIExtension extends CardUIExtension {

    private _disposer: Function | null = null;

  public initialized(context: ICardUIExtensionContext) {
    if (context.model == null ||
        context.model.card == null) {
      return;
    }
    if (!(
        Guid.equals(context.model.card.typeId, CdCardTypes.PkIncomingTypeID) ||
        Guid.equals(context.model.card.typeId, CdCardTypes.PkMemoTypeID) ||
        Guid.equals(context.model.card.typeId, CdCardTypes.PkOutgoingTypeID) ||
        Guid.equals(context.model.card.typeId, CdCardTypes.RdndTypeID) ||
        Guid.equals(context.model.card.typeId, CdCardTypes.PkInternalDocumentationTypeID) ||
        Guid.equals(context.model.card.typeId, CdCardTypes.PkAssignmentTypeID) ||
        Guid.equals(context.model.card.typeId, CdCardTypes.PkLetterCreditTypeID) ||
        Guid.equals(context.model.card.typeId, CdCardTypes.InstructionTypeID) ||
        Guid.equals(context.model.card.typeId, CdCardTypes.ArActTypeID) ||
        Guid.equals(context.model.card.typeId, CdCardTypes.ArDocumentIdpTypeID) ||
        Guid.equals(context.model.card.typeId, CdCardTypes.TechnicalDocumentationTypeID) ||
        Guid.equals(context.model.card.typeId, CdCardTypes.ArEDocumentTypeID) ||
        Guid.equals(context.model.card.typeId, CdCardTypes.PkRequestForMaterialsTypeID)
    )) {
        return;
    }

    let tasks = context.model.tryGetTasks();
    if (tasks == null || tasks.length < 1) return;
    for (let task of tasks) {
        // при инциализации формы
        this.HideSubTaskTable(task);
        // подписываемся на изменения формы в задании
        task.workspaceChanged.add(e => this.HideSubTaskTable(e.task));
    }
  }

    private HideSubTaskTable(task: TaskViewModel) {
        let hasSubTasks = false;
        let ptisvSection = task.taskModel.card.sections.tryGet('PkTasksInfoSubtasksVirtual');
        if (ptisvSection != null) {
            hasSubTasks = ptisvSection.rows.length > 0 ? true : false;
        }
        const control = task.taskModel.blocks.get('SubTasksBlock');
        if (control) {
            control.blockVisibility = hasSubTasks ? Visibility.Visible : Visibility.Collapsed;
        }
    }

  public finalized() {
      // подчищаем за собой
      if (this._disposer) {
          this._disposer();
          this._disposer = null;
      }
  }
}